import React from "react";
import ReusablePDFLayout from "../ReusablePDFLayout";

export const Page6 = () => {
  return (
    <ReusablePDFLayout>
      <div className="parentcls">
        <ul style={{ margin: "10px 40px" }} className="para">
          <li style={{ paddingLeft: "15px" }}>
            Established misappropriation of any Tangible and/or intangible
            assets of the Company
          </li>
          <li style={{ paddingLeft: "15px" }}>
            Intentional Misuse of Company or Company’s clientele data.
          </li>
        </ul>
        <p className="para">
          Your employment hereunder is only subject to the information and
          particulars furnished by you and if it transpires that you have made a
          false statement or concealed a material fact resulting in your
          employment with us, the Management may take such action as it deems
          fit in its sole discretion, including termination of your employment.
        </p>
        {/* <table
          className="tableStyle"
          border="1"
          cellSpacing="0"
          cellPadding="5"
          style={{margin:"80px 30px 0 40px"}}
        >
          <tr>
            <td rowSpan="2">Designation</td>
            <td colSpan="2" style={{textAlign:"center"}}>Notice Period</td>
          </tr>
          <tr>
            <td>During Probation</td>
            <td>After Probation</td>
          </tr>
          <tr>
            <td>Team Leaders and above</td>
            <td>30 days</td>
            <td>90 days</td>
          </tr>
          <tr>
            <td>Trainees / Executives</td>
            <td>30 days</td>
            <td>60 days</td>
          </tr>
        </table> */}
        <table
  className="tableStyle"
  border="1"
  cellSpacing="0"
  cellPadding="5"
  style={{ margin: "25px 39px 0px 5px" }}
>
  <thead>
    <tr>
      <td rowSpan="2" >Designation</td>
      <td colSpan="2" style={{ textAlign: "center" }}>Notice Period</td>
    </tr>
    <tr>
      <td>During Probation</td>
      <td>After Probation</td>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Team Leaders and above</td>
      <td>30 days</td>
      <td>90 days</td>
    </tr>
    <tr>
      <td>Trainees / Executives</td>
      <td>30 days</td>
      <td>60 days</td>
    </tr>
  </tbody>
</table>

        <p className="para" style={{marginTop:'3px'}}>
          You are not eligible for any leave during the Notice Period
        </p>
        <p className="bolds" style={{margin:"25px 0"}}>Indemnity:</p>
        <p className="para" style={{margin:"25px 0"}}>
          You shall be responsible for properly and diligently performing the
          duties assigned to you, for maintaining the confidentiality of
          confidential information and trade secrets of the Company and for
          protecting the property of the Company entrusted to you in the due
          discharge of your duties. You shall fully indemnify and keep the
          Company fully Indemnified against any claim or demand made against the
          Company in this regard. You shall continue to indemnify the Company
          even after the expiry or termination of this employment against any
          claim or demand made against the Company with regard to any acts or
          omissions committed by you during your employment with us.
        </p>
        <p className="para" style={{margin:"25px 0"}}>
          In the event of you leaving the Company prior to the completion of one
          (1) year from the commencement of this employment contract, you shall
          indemnify the company against all expenses, whatsoever, incurred on
          you by the Company by repaying any and all such expenses and
          reimbursements to the Company including but not limited to such amount
          which will be deducted from your Full and Final Settlement.
        </p>
      </div>
    </ReusablePDFLayout>
  );
};
